import { Card, CardBody, Col } from "reactstrap";
import { fileUploadData } from "../../../../Data/BonusUi/Dropzone/Dropzone";
import CardHeaderCommon from "../../../../Utils/CommonComponents/CardHeaderCommon";
import CommonFileUpload from "../../../../Utils/CommonComponents/CommonFileUpload";
import { SingleFileUploads } from "../../../../Utils/Constants";

const SingleFileupload = () => {
  return (
    <Col lg="6">
      <Card>
        <CardHeaderCommon title={SingleFileUploads} span={fileUploadData} />
        <CardBody>
          <CommonFileUpload />
        </CardBody>
      </Card>
    </Col>
  );
};

export default SingleFileupload;
